import React from 'react'
import '../filtersearch/FilterSearch.css'
import { Link } from 'react-router-dom'

const FilterSearch = () => {
  return (
    <div className='filter-search-box'>
        <h2>Filter</h2>
        <div className='scroll-filter-box'>
            <div className='filter-box mb-4'>
                <h3>Event</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios9" id="" value="option9" />
                            <label className="form-check-label" for="">Hens Night</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios9" id="" value="option9" />
                            <label className="form-check-label" for="">Bucks Night</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios9" id="" value="option9" />
                            <label className="form-check-label" for="">Private</label>
                        </div>
                    </li>
                </ul>
            </div>
            <div className='filter-box mb-4'>
                <h3>Ethnicity</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">Caucasian</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">Hispanic/Latina</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">European</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">African</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios" id="" value="option1" />
                            <label className="form-check-label" for="">Asian</label>
                        </div>
                    </li>
                </ul>
            </div>
            <div className='filter-box mb-4'>
                <h3>Rating</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios2" id="" value="option2" />
                            <label className="form-check-label" for="">High to Low</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios2" id="" value="option2" />
                            <label className="form-check-label" for="">Top Rated</label>
                        </div>
                    </li>
                </ul>
            </div>
            <div className='filter-box mb-4'>
                <h3>Generosity</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios3" id="" value="option3" />
                            <label className="form-check-label" for="">High to Low</label>
                        </div>
                    </li>
                </ul>
            </div>
            <div className='filter-box mb-4'>
                <h3>Sex</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios4" id="" value="option4" />
                            <label className="form-check-label" for="">Female</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios4" id="" value="option4" />
                            <label className="form-check-label" for="">Male</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios4" id="" value="option4" />
                            <label className="form-check-label" for="">Trans Female</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios4" id="" value="option4" />
                            <label className="form-check-label" for="">Trans Male</label>
                        </div>
                    </li>
                </ul>
            </div>
            <div className='filter-box mb-4'>
                <h3>Service</h3>
                <ul className='radio-box-checked'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios5" id="" value="option5" />
                            <label className="form-check-label" for="">Stripping (full nude)</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios5" id="" value="option5" />
                            <label className="form-check-label" for="">Topless</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="exampleRadios5" id="" value="option5" />
                            <label className="form-check-label" for="">Escorting</label>
                        </div>
                    </li>
                </ul>
            </div>
            <div className='filter-box filter-btn-bottom-box'>
                <ul className='radio-box-checked column-gap-3 d-flex flex-wrap mt-4'>
                    <li className='w-100 mb-2'>
                        <Link rel='stylesheet' className='btn btn-border Active-filter d-block w-100'>Apply</Link>
                    </li>
                    <li className='w-100'>
                        <Link rel='stylesheet' className=' btn btn-border'>Clear All</Link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
  )
}

export default FilterSearch
